var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6883 3.52151C33.2985 2.91132 33.2985 1.922 32.6883 1.3118C32.0781 0.701608 31.0888 0.701608 30.4786 1.3118L17.0001 14.7903L3.5216 1.31181C2.91141 0.701614 1.92209 0.701614 1.31189 1.31181C0.701699 1.922 0.701699 2.91132 1.31189 3.52152L14.7904 17L1.31195 30.4785C0.701756 31.0887 0.701756 32.078 1.31195 32.6882C1.92214 33.2984 2.91146 33.2984 3.52166 32.6882L17.0001 19.2097L30.4786 32.6882C31.0888 33.2984 32.0781 33.2984 32.6883 32.6882C33.2985 32.078 33.2985 31.0887 32.6883 30.4785L19.2098 17L32.6883 3.52151Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.45d2348e7d2d0d6eaac27c9195ab0406.svg";
export { ForwardRef as ReactComponent };